<template>
  <div>
    <div ref="component" class="simple cx_style">
      <div class="content-item">
        <div class="content flex">
          <div class="upload" :class="'img-size-' + size">
            <span v-show="!noImg && showDel" class="icon-portal-delete del-bg-icon" @click="delBgImage"></span>
            <img :src="imgVal || defaultImg" name="uploadFile" />
          </div>
          <div class="text ml16">
            <div class="description mb2">格式：PNG/JPG/GIF</div>
            <div class="description mb2">大小：{{maxSize}} M以下</div>
            <div class="description mb2" v-if="showSize">尺寸：{{ imgSize }}px</div>
            <div class="mt7 upload-btns">
              <span class="common_btn_28_20 mr10">
                <input
                  type="file"
                  accept="image/gif,image/jpeg,image/jpg,image/png"
                  @change="uploadImg($event)"
                />上传</span
              >
              <span v-if="noImgLib" class="common_btn_28_20 open_lib_btn" @click="openImgLib">资源库</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--图片库-->
    <resourceLib :visible.sync="imgResDialogVisible" :imgSrc.sync="imgVal" :iconColor.sync="iconColorVal" />
  </div>
</template>

<script>
import "../common.css"
import publicData from "../mixins/publicData.js"
import primaryImg from "assets/images/primaryImage.png"
import emptyImg from "assets/images/empty_img_bg.png"
import { uploadResources } from "../../utils"
import resourceLib from "./resourceLib"
export default {
  mixins: [publicData],
  name: "img-upload",
  components: { resourceLib },
  props: {
    imgSrc: {
      type: String,
      required: true
    },
    defaultImg: {
      type: String,
      required: false
    },
    maxSize: {
      type: Number,
      default: 1
    },
    size: {
      type: String,
      default: "small",
      required: false
    },
    noImgLib: {
      type: Boolean,
      default: true,
      required: false
    },
    imgSize: {
      type: String,
      default: "1920*220",
      required: false
    },
    iconColor: {
      type: String,
      default: "#444444",
      required: false
    },
    showDel: {
      type: Boolean,
      default: true,
      required: false
    },
    showSize: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  data() {
    return {
      imgResDialogVisible: false,
      contextPath: "",
      noImg: true,
      leftMenuList: [],
      leftMenuActiveIndex: 0,
      leftMenuCurrentIndex: 0,
      rightCatetoryList: [],
      rightImgList: [],
      rightCatetoryActiveIndex: -1,
      searchResultLength: -1,
      totalNum: 0
    }
  },
  computed: {
    imgVal: {
      get() {
        this.noImg = this?.imgSrc?.length === 0 ? true : false
        return this?.imgSrc?.length ? this.imgSrc : this.request_prefix === "bigScreen" ? emptyImg : primaryImg
      },
      set(val) {
        this.$emit("update:imgSrc", val)
      }
    },
    wfwfid() {
      return this.$store.state.states.getDataPageIds.wfwfid
    },
    iconColorVal: {
      get() {
        return this.iconColor || ""
      },
      set(val) {
        this.$emit("update:iconColor", val)
      }
    }
  },
  mounted() {
    this.contextPath = window.hasOwnProperty("p_contextpath") ? window["p_contextpath"] : ""
  },
  methods: {
    uploadImg(e) {
      console.log(e.target.files[0])
      let file = e.target.files[0]
      let _this = this
      uploadResources(file, 5, this, function (imgSrc) {
        _this.imgVal = imgSrc
      })
      e.target.value = null
    },
    delBgImage() {
      this.imgVal = ""
    },
    openImgLib() {
      this.imgResDialogVisible = true
      this.getImgAllTypes()
    },
    getImgAllTypes() {
      this.instance
        .get(this.contextPath + "v2/resource/all-classify?type=1", {
          wfwfid: this.wfwfid
        })
        .then(res => {
          if (res.data.code === 1) {
            this.leftMenuList = res.data.data
            if (this.leftMenuActiveIndex == 0) {
              this.leftMenuActiveIndex = res.data.data[0].id
            }
            if (this.rightCatetoryActiveIndex == -1) {
              this.rightCatetoryActiveIndex = res.data.data[0].subClassify[0].id
            }
            if (this.leftMenuCurrentIndex !== -1) {
              this.rightCatetoryList = res.data.data[this.leftMenuCurrentIndex].subClassify
              this.getRightImgList(this.leftMenuActiveIndex, this.rightCatetoryActiveIndex, "")
            } else {
              this.getMyUploadImg()
            }
          }
        })
    },
    getRightImgList(firstClassifyId, secondClassifyId, pageNum, tag) {
      tag = typeof tag == "undefined" ? "" : tag
      this.instance
        .get(this.contextPath + "v2/resource/query-by-classify", {
          params: {
            wfwfid: this.wfwfid,
            firstClassifyId: firstClassifyId,
            secondClassifyId: secondClassifyId,
            pageNum: pageNum || 1,
            pageSize: 20,
            tag: tag
          }
        })
        .then(res => {
          if (res.data.code === 1) {
            for (let i = 0; i < res.data.data.list.length; i++) {
              res.data.data.list[i].content = JSON.parse(res.data.data.list[i].content)
            }
            this.rightImgList = res.data.data.list
            this.totalNum = res.data.data.total
            if (tag.length !== 0 && res.data.data.list.length == 0) {
              this.searchResultLength = 0
            } else {
              this.searchResultLength = -1
            }
          }
        })
    },
    getMyUploadImg() {
      this.instance.get(this.contextPath + "v2/resource/query-my-upload").then(res => {
        if (res.data.code === 1) {
          for (let i = 0; i < res.data.data.list.length; i++) {
            res.data.data.list[i].content = JSON.parse(res.data.data.list[i].content)
          }
          this.totalNum = res.data.data.total
          this.rightImgList = res.data.data.list
        }
      })
    }
  }
}
</script>

<style scoped>
/*图片上传出的样式*/
.upload {
  position: relative;
}
.upload .del-bg-icon {
  position: absolute;
  top: 4px;
  right: 4px;
  z-index: 10;
  cursor: pointer;
}
.content .upload {
  width: 90px;
  height: 90px;
}
.content .img-size-small {
  width: 90px;
  height: 90px;
}
.content .img-size-medium {
  width: 90px;
  height: 90px;
}
.content .upload img {
  width: 100%;
  height: 100%;
  border-radius: 4px;
  object-fit: cover;
}
.content .upload .del-bg-icon {
  position: absolute;
  display: none;
  bottom: 4px;
  top: auto;
  right: 4px;
  z-index: 10;
  cursor: pointer;
  width: 18px;
  line-height: 18px;
  text-align: center;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 3px;
  color: #ffffff;
}
.content .upload .del-bg-icon:hover {
  background: rgba(0, 0, 0, 0.8);
}
.content .upload:hover .del-bg-icon {
  display: block;
}
.upload-btns input[type="file"] {
  width: 38px;
}
.upload-btns span {
  cursor: pointer;
}
.el-select:hover .el-input__inner {
  border: none;
}
.el-color-dropdown .el-input__inner {
  background: #f7f7f7;
}
.content .description {
  font-size: 12px;
  line-height: 17px;
}
.img-boxs > li {
  display: inline-block;
  vertical-align: top;
  margin: 10px;
}
.img-boxs img {
  width: 130px;
  height: 74px;
  box-sizing: border-box;
  cursor: pointer;
}
.img-boxs img:hover {
  border: 1px solid rgba(8, 140, 223, 1);
}
::v-deep .el-scrollbar__wrap {
  overflow-y: scroll;
  overflow-x: hidden;
  height: 100%;
}
::v-deep .scrollbar {
  height: calc(100% - 40px);
}
::v-deep .el-dialog__headerbtn {
  top: 18px;
  right: 24px;
}
::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: var(--imgDialogIconColor);
  font-size: 20px;
}
.img-set-dialog-wrap {
  position: fixed;
  top: 0;
  right: 0;
  width: 300px;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 9999;
}
.img-set-dialog-wrap .img-set-dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #ffffff;
  width: 210px;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #e9e9e9;
  box-shadow: 0px 6px 16px -8px rgba(0, 0, 0, 0.08), 0px 9px 28px rgba(0, 0, 0, 0.05),
    0px 12px 48px 16px rgba(0, 0, 0, 0.03);
}
.img-set-dialog-wrap .dialog-header {
  position: relative;
  padding: 9.5px 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);
  height: 40px;
  line-height: 20px;
}
.img-set-dialog-wrap .dialog-header .dialog-title {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: rgba(0, 0, 0, 0.8);
}
.img-set-dialog-wrap .dialog-header .icon-portal-close {
  position: absolute;
  right: 12px;
  top: 12px;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.6);
}
.img-set-dialog-wrap .dialog-body {
  padding: 16px 12px;
  height: 300px;
  overflow-y: auto;
}
.img-set-dialog-wrap .dialog-body .img-title {
  color: rgba(0, 0, 0, 0.6);
  font-size: 14px;
  line-height: 20px;
}
.img-set-dialog-wrap .dialog-body .img-boxs {
  margin-bottom: 16px;
  display: flex;
  flex-wrap: wrap;
}
.img-set-dialog-wrap .dialog-body .img-boxs:last-child {
  margin-bottom: 0;
}
.img-set-dialog-wrap .dialog-body .img-boxs > li {
  background: #ffffff;
  border: 1px solid #e9e9e9;
  box-sizing: border-box;
  border-radius: 4px;
  width: 40px;
  height: 40px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 8px 8px 0 0;
}
.img-set-dialog-wrap .dialog-body .img-boxs > li:nth-child(4n) {
  margin-right: 0;
}
.img-set-dialog-wrap .dialog-body .img-boxs img {
  width: 24px;
  height: 24px;
}
.img-set-dialog-wrap .dialog-body .img-boxs img:hover {
  border: none;
}
::v-deep .el-scrollbar__view {
  display: flex;
}

/* 分页 */
.el-pagination {
  text-align: center;
}
::v-deep .el-pagination button,
.el-pagination span:not([class*="suffix"]),
::v-deep .el-pager li {
  height: 24px;
  line-height: 24px;
}
</style>
